import {envs} from './envs';
import {MIN_VERSIONS_MB_TYPE} from './types';

export const clientRoutes = {
  Main: '/',
  MainMb: '/?mbversion=1`',
  AuthUser: '/auth/user',
  AuthLogin: '/auth/login',
} as const;

const queriesSubRoute = envs.APP_PROJECT_API_USE_CQRS ? '/queries' : '';
const commandsSubRoute = envs.APP_PROJECT_API_USE_CQRS ? '/commands' : '';

export const apiRoutes = {
  auth: {
    login: `${commandsSubRoute}/v1/auth/login`,
    logout: `${commandsSubRoute}/v1/auth/logout`,
  },
  user: {
    info: `${queriesSubRoute}/v1/users/info`,
    updateIsSubscribedToNotifications: `${commandsSubRoute}/v1/users/notifications/toggle`,
    updateIsOpenedAllItems: `${commandsSubRoute}/v1/users/is_opened_all_items/toggle`,
    finishOnboarding: `${commandsSubRoute}/v1/users/onboarding/finish`,
  },
  items: {
    open: `${commandsSubRoute}/v1/users/items/%itemId%/open`,
  },
  bonuses: {
    open: `${commandsSubRoute}/v1/users/items/%itemId%/bonuses/%bonusId%/open`,
  },
} as const;

export enum HTMLElementId {
  Statistic = 'statistic',
  Items = 'items',
  ItemsTitle = 'itemsTitle',
}

export const SCROLL_TO_PREFIX = 'scroll_to_';

export const MAX_USER_ENERGY_NEXT_IN_VALUE = 28800000;

export const MAX_STATISTIC_ITEM_STRING_VALUE_LENGTH = 20;

export const MIN_STATISTIC_ITEM_STRING_VALUE_LENGTH = 1;

export const MAX_STATISTIC_ITEM_FLOAT_VALUE_SIGNS_AFTER_COMMA = 2;

export const STATISTIC_ITEM_HUGE_VALUE_SIGNS_AFTER_COMMA = 1;

export const ONE_MINUTE_IN_SECONDS = 60;

export const SECONDS_VALIDATION_MULTIPLIER = 10;

export const ONE_HOUR_IN_SECONDS = 3600;

export const MIN_HUGE_VALUE = 1e6;

export const MEASURE_TEMPLATE_VALUE = '%measure%';

export const MILLION_ABBR = 'млн';

export const BILLION_ABBR = 'млрд';

export enum ProjectFontFamily {
  TTFirsDemiBold = 'TTFirsDemiBold',
  TTFirsMedium = 'TTFirsMedium',
}

export const SMALL_SCREEN_WIDTH = 375;
export const DESKTOP_SCREEN_WIDTH = 1024;
export const TABLET_SCREEN_WIDTH = 600;

export const HUGE_VALIDATION_VALUE_THRESHOLD = 49;

export const PETS_FAV_ITEM_BLACK_LIST: Set<string> = new Set([]);

export const GROCERY_FAV_ITEM_BLACK_LIST: Set<string> = new Set([]);

export const TFOOD_FAV_ITEM_BLACK_LIST: Set<string> = new Set([]);

export const AMT_2025_TRAN_AMT_WHITE_LIST: Set<number> = new Set([2025, 202.5, 20.25]);

export const CURRENT_STATISTIC_YEAR = 2024;

export const MONTH_VARIANTS = [
  ['Январь', 'Январе', 'Января'],
  ['Февраль', 'Феврале', 'Февраля'],
  ['Март', 'Марте', 'Марта'],
  ['Апрель', 'Апреле', 'Апреля'],
  ['Май', 'Мае', 'Мая'],
  ['Июнь', 'Июне', 'Июня'],
  ['Июль', 'Июле', 'Июля'],
  ['Август', 'Августе', 'Августа'],
  ['Сентябрь', 'Сентябре', 'Сентября'],
  ['Октябрь', 'Октябре', 'Октября'],
  ['Ноябрь', 'Ноябре', 'Ноября'],
  ['Декабрь', 'Декабре', 'Декабря'],
];

export const COUNT_STATISTIC_ITEMS_WEB = 4;
export enum IMAGE_LOADING_ENUM {
  Eager = 'eager',
  Lazy = 'lazy',
}

export const TIMER_ID_NO_ACTIVE = -1;

export const MIN_VERSIONS_MB: MIN_VERSIONS_MB_TYPE = {
  minimalPurchase: {
    ios: '6.46',
    android: '6.43',
  },
  assistant: {
    ios: '',
    android: '6.15',
  },
};

export enum COMPLETION_MODAL {
  ProjectFinishesSoon = 'ProjectFinishesSoon',
  ProjectFinished = 'ProjectFinished',
  Null = 'null',
}

export const COUNT_MS_IN_ONE_DAY = 1000 * 3600 * 24;

export enum TitleFinishesSoonModalText {
  oneDay = 'Остался',
  moreDays = 'Осталось',
}


//PROJECT_ID для тестового топика в buggie
export const PROJECT_ID_TOPIC = '01J03MSWEG7V2Q7NXWC79WRER3';
//PROJECT_ID для тестового инцидента в buggie
export const PROJECT_ID_INCIDENT = '01HYA5VZQJ79Q8GEMCJZNJK0AF';
export const COOKIE_EXPIRE_SECONDS = 60;
export const COOKIES_PATH = '/';
